uniform vec3 topColor;
uniform vec3 bottomColor;
uniform float offset;
uniform float uvMulti;
uniform float noiseScale;

varying vec2 vUv;

uniform float noiseStrength;

uniform sampler2D noiseTexture;

vec3 getNoise(vec2 uv) {
  float noiseForce = noiseStrength;

  float force = noiseForce;
  vec4 n = texture2D(noiseTexture, uv * noiseScale) / force;
  // vec4 n = texture2D(noiseTexture, uv * noiseScale);
  return n.xyz;
}

void main() {
  // vec3 col = vec3(vUv.y + offset, 0., 0.);
  vec3 col = mix(bottomColor, topColor, clamp(vUv.y * uvMulti + offset, 0., 1.));
  col.rgb += getNoise(vUv);

  // gl_FragColor = linearToOutputTexel(vec4(col, 1.));
  gl_FragColor = vec4(col, 1.);
}